import _toConsumableArray from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __accessCheck = function __accessCheck(obj, member, msg) {
  if (!member.has(obj)) throw TypeError("Cannot " + msg);
};

var __privateGet = function __privateGet(obj, member, getter) {
  __accessCheck(obj, member, "read from private field");

  return getter ? getter.call(obj) : member.get(obj);
};

var __privateAdd = function __privateAdd(obj, member, value) {
  if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};

var __privateSet = function __privateSet(obj, member, value, setter) {
  __accessCheck(obj, member, "write to private field");

  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};

var __privateMethod = function __privateMethod(obj, member, method) {
  __accessCheck(obj, member, "access private method");

  return method;
};

var _mediaController, _keysSoFar, _clearKeysTimeout, _metaPressed, _clickListener, _handleKeyListener, handleKeyListener_fn, _keyupListener, _keydownListener, _updateLayoutStyle, updateLayoutStyle_fn, _getOption, getOption_fn, _selectOption, selectOption_fn, _searchOption, searchOption_fn, _clearKeysOnDelay, clearKeysOnDelay_fn;

import { MediaStateReceiverAttributes } from "../constants.js";
import { globalThis, document } from "../utils/server-safe-globals.js";
var checkIcon = "\n<svg aria-hidden=\"true\" viewBox=\"0 1 24 24\" part=\"select-indicator indicator\">\n  <path d=\"m10 15.17 9.193-9.191 1.414 1.414-10.606 10.606-6.364-6.364 1.414-1.414 4.95 4.95Z\"/>\n</svg>";

function createOption(text, value, selected) {
  var option = document.createElement("media-chrome-option");
  option.part.add("option");
  option.value = value;
  option.selected = selected;
  var label = document.createElement("span");
  label.textContent = text;
  option.append(label);
  return option;
}

function createIndicator(el, name) {
  var customIndicator = el.querySelector(":scope > [slot=\"".concat(name, "\"]"));
  if ((customIndicator == null ? void 0 : customIndicator.nodeName) == "SLOT") customIndicator = customIndicator.assignedElements({
    flatten: true
  })[0];

  if (customIndicator) {
    customIndicator = customIndicator.cloneNode(true);
    customIndicator.removeAttribute("slot");
    return customIndicator;
  }

  var fallbackIndicator = el.shadowRoot.querySelector("[name=\"".concat(name, "\"] > svg"));
  return fallbackIndicator.cloneNode(true);
}

var template = document.createElement("template");
template.innerHTML = "\n<style>\n  :host {\n    font: var(--media-font,\n      var(--media-font-weight, normal)\n      var(--media-font-size, 15px) /\n      var(--media-text-content-height, var(--media-control-height, 24px))\n      var(--media-font-family, helvetica neue, segoe ui, roboto, arial, sans-serif));\n    color: var(--media-text-color, var(--media-primary-color, rgb(238 238 238)));\n    background: var(--media-listbox-background, var(--media-control-background, var(--media-secondary-color, rgb(20 20 30 / .8))));\n    border-radius: var(--media-listbox-border-radius);\n    display: inline-flex;\n    flex-direction: column;\n    position: relative;\n    box-sizing: border-box;\n  }\n\n  ::slotted([slot=\"header\"]) {\n    padding: .4em 1.4em;\n    border-bottom: 1px solid rgb(255 255 255 / .25);\n  }\n\n  #container {\n    gap: var(--media-listbox-gap);\n    display: flex;\n    flex-direction: var(--media-listbox-flex-direction, column);\n    overflow: hidden auto;\n    padding-block: .5em;\n  }\n\n  media-chrome-option {\n    padding-inline: .7em 1.4em;\n  }\n\n  media-chrome-option > span {\n    margin-inline: .5ch;\n  }\n\n  [part~=\"indicator\"] {\n    fill: var(--media-option-indicator-fill, var(--media-icon-color, var(--media-primary-color, rgb(238 238 238))));\n    height: var(--media-option-indicator-height, 1.25em);\n    vertical-align: var(--media-option-indicator-vertical-align, text-top);\n  }\n\n  [part~=\"select-indicator\"] {\n    display: var(--media-option-select-indicator-display);\n    visibility: hidden;\n  }\n\n  [aria-selected=\"true\"] > [part~=\"select-indicator\"] {\n    visibility: visible;\n  }\n</style>\n<style id=\"layout-row\" media=\"width:0\">\n\n  ::slotted([slot=\"header\"]) {\n    padding: .4em .5em;\n  }\n\n  #container {\n    gap: var(--media-listbox-gap, .25em);\n    flex-direction: var(--media-listbox-flex-direction, row);\n    padding-inline: .5em;\n  }\n\n  media-chrome-option {\n    padding: .3em .24em;\n  }\n\n  media-chrome-option[aria-selected=\"true\"] {\n    background: var(--media-option-selected-background, rgb(255 255 255 / .2));\n  }\n\n  [part~=\"select-indicator\"] {\n    display: var(--media-option-select-indicator-display, none);\n  }\n</style>\n<slot name=\"header\"></slot>\n<slot id=\"container\"></slot>\n<slot name=\"select-indicator\" hidden>".concat(checkIcon, "</slot>\n");

var MediaChromeListbox = /*#__PURE__*/function (_globalThis$HTMLEleme) {
  _inherits(MediaChromeListbox, _globalThis$HTMLEleme);

  var _super = _createSuper(MediaChromeListbox);

  function MediaChromeListbox() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, MediaChromeListbox);

    _this = _super.call(this);

    __privateAdd(_assertThisInitialized(_this), _handleKeyListener);

    __privateAdd(_assertThisInitialized(_this), _updateLayoutStyle);

    __privateAdd(_assertThisInitialized(_this), _getOption);

    __privateAdd(_assertThisInitialized(_this), _selectOption);

    __privateAdd(_assertThisInitialized(_this), _searchOption);

    __privateAdd(_assertThisInitialized(_this), _clearKeysOnDelay);

    __privateAdd(_assertThisInitialized(_this), _mediaController, void 0);

    __privateAdd(_assertThisInitialized(_this), _keysSoFar, "");

    __privateAdd(_assertThisInitialized(_this), _clearKeysTimeout, null);

    __privateAdd(_assertThisInitialized(_this), _metaPressed, false);

    __privateAdd(_assertThisInitialized(_this), _clickListener, function (e) {
      _this.handleClick(e);
    });

    __privateAdd(_assertThisInitialized(_this), _keyupListener, function (e) {
      var key = e.key;

      if (key === "Escape") {
        _this.removeEventListener("keyup", __privateGet(_assertThisInitialized(_this), _keyupListener));

        return;
      }

      if (key === "Meta") {
        __privateSet(_assertThisInitialized(_this), _metaPressed, false);

        return;
      }

      __privateMethod(_assertThisInitialized(_this), _handleKeyListener, handleKeyListener_fn).call(_assertThisInitialized(_this), e);
    });

    __privateAdd(_assertThisInitialized(_this), _keydownListener, function (e) {
      var key = e.key,
          altKey = e.altKey;

      if (altKey) {
        _this.removeEventListener("keyup", __privateGet(_assertThisInitialized(_this), _keyupListener));

        return;
      }

      if (key === "Meta") {
        __privateSet(_assertThisInitialized(_this), _metaPressed, true);

        return;
      }

      if (_this.keysUsed.includes(key)) {
        e.preventDefault();
      }

      if (__privateGet(_assertThisInitialized(_this), _metaPressed) && _this.keysUsed.includes(key)) {
        __privateMethod(_assertThisInitialized(_this), _handleKeyListener, handleKeyListener_fn).call(_assertThisInitialized(_this), e);

        return;
      }

      _this.addEventListener("keyup", __privateGet(_assertThisInitialized(_this), _keyupListener), {
        once: true
      });
    });

    if (!_this.shadowRoot) {
      _this.attachShadow({
        mode: "open"
      });

      _this.nativeEl = template.content.cloneNode(true);

      if (options.slotTemplate) {
        _this.nativeEl.append(options.slotTemplate.content.cloneNode(true));
      }

      _this.shadowRoot.append(_this.nativeEl);
    }

    _this.container = _this.shadowRoot.querySelector("#container");

    _this.container.addEventListener("slotchange", function (event) {
      var _iterator = _createForOfIteratorHelper(event.target.assignedNodes({
        flatten: true
      })),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var node = _step.value;

          if (node.nodeType === 3 && node.textContent.trim() === "") {
            node.remove();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });

    return _this;
  }

  _createClass(MediaChromeListbox, [{
    key: "formatOptionText",
    value: function formatOptionText(text, data) {
      return this.constructor.formatOptionText(text, data);
    }
  }, {
    key: "options",
    get: function get() {
      var _a;

      var options = this.querySelectorAll("media-chrome-option");

      if (!options.length) {
        options = (_a = this.container) == null ? void 0 : _a.querySelectorAll("media-chrome-option");
      }

      return Array.from(options);
    }
  }, {
    key: "selectedOptions",
    get: function get() {
      return this.options.filter(function (option) {
        return option.selected;
      });
    }
  }, {
    key: "value",
    get: function get() {
      var _a, _b;

      return (_b = (_a = this.selectedOptions[0]) == null ? void 0 : _a.value) != null ? _b : "";
    },
    set: function set(newValue) {
      var option = this.options.find(function (option2) {
        return option2.value === newValue;
      });
      if (!option) return;

      __privateMethod(this, _selectOption, selectOption_fn).call(this, option);
    }
  }, {
    key: "focus",
    value: function focus() {
      var _a;

      (_a = this.selectedOptions[0]) == null ? void 0 : _a.focus();
    }
  }, {
    key: "enable",
    value: function enable() {
      this.addEventListener("click", __privateGet(this, _clickListener));
      this.addEventListener("keydown", __privateGet(this, _keydownListener));
    }
  }, {
    key: "disable",
    value: function disable() {
      this.removeEventListener("click", __privateGet(this, _clickListener));
      this.removeEventListener("keyup", __privateGet(this, _keyupListener));
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, oldValue, newValue) {
      var _a, _b, _c, _d, _e;

      if (attrName === "style" && newValue !== oldValue) {
        __privateMethod(this, _updateLayoutStyle, updateLayoutStyle_fn).call(this);
      } else if (attrName === MediaStateReceiverAttributes.MEDIA_CONTROLLER) {
        if (oldValue) {
          (_b = (_a = __privateGet(this, _mediaController)) == null ? void 0 : _a.unassociateElement) == null ? void 0 : _b.call(_a, this);

          __privateSet(this, _mediaController, null);
        }

        if (newValue && this.isConnected) {
          __privateSet(this, _mediaController, (_c = this.getRootNode()) == null ? void 0 : _c.getElementById(newValue));

          (_e = (_d = __privateGet(this, _mediaController)) == null ? void 0 : _d.associateElement) == null ? void 0 : _e.call(_d, this);
        }
      } else if (attrName === "disabled" && newValue !== oldValue) {
        if (newValue == null) {
          this.enable();
        } else {
          this.disable();
        }
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _a, _b, _c;

      __privateMethod(this, _updateLayoutStyle, updateLayoutStyle_fn).call(this);

      if (!this.hasAttribute("disabled")) {
        this.enable();
      }

      if (!this.hasAttribute("role")) {
        this.setAttribute("role", "listbox");
      }

      var mediaControllerId = this.getAttribute(MediaStateReceiverAttributes.MEDIA_CONTROLLER);

      if (mediaControllerId) {
        __privateSet(this, _mediaController, (_a = this.getRootNode()) == null ? void 0 : _a.getElementById(mediaControllerId));

        (_c = (_b = __privateGet(this, _mediaController)) == null ? void 0 : _b.associateElement) == null ? void 0 : _c.call(_b, this);
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _a, _b;

      this.disable();
      (_b = (_a = __privateGet(this, _mediaController)) == null ? void 0 : _a.unassociateElement) == null ? void 0 : _b.call(_a, this);

      __privateSet(this, _mediaController, null);
    }
  }, {
    key: "keysUsed",
    get: function get() {
      return ["Enter", " ", "ArrowDown", "ArrowUp", "Home", "End"];
    }
  }, {
    key: "handleSelection",
    value: function handleSelection(e, toggle) {
      var option = __privateMethod(this, _getOption, getOption_fn).call(this, e);

      if (!option) return;

      __privateMethod(this, _selectOption, selectOption_fn).call(this, option, toggle);
    }
  }, {
    key: "handleMovement",
    value: function handleMovement(e) {
      var key = e.key;
      var els = this.options;

      var currentOption = __privateMethod(this, _getOption, getOption_fn).call(this, e);

      if (!currentOption) {
        currentOption = els.filter(function (el) {
          return el.getAttribute("tabindex") === "0";
        })[0];
      }

      var nextOption;

      switch (key) {
        case "ArrowDown":
          nextOption = currentOption.nextElementSibling;

          if (nextOption == null ? void 0 : nextOption.hasAttribute("disabled")) {
            nextOption = nextOption.nextElementSibling;
          }

          break;

        case "ArrowUp":
          nextOption = currentOption.previousElementSibling;

          if (nextOption == null ? void 0 : nextOption.hasAttribute("disabled")) {
            nextOption = nextOption.previousElementSibling;
          }

          break;

        case "Home":
          nextOption = els[0];
          break;

        case "End":
          nextOption = els[els.length - 1];
          break;

        default:
          nextOption = __privateMethod(this, _searchOption, searchOption_fn).call(this, key);
          break;
      }

      if (nextOption) {
        els.forEach(function (el) {
          return el.setAttribute("tabindex", "-1");
        });
        nextOption.setAttribute("tabindex", "0");
        nextOption.focus();
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      var option = __privateMethod(this, _getOption, getOption_fn).call(this, e);

      if (!option || option.hasAttribute("disabled")) return;
      this.options.forEach(function (el) {
        return el.setAttribute("tabindex", "-1");
      });
      option.setAttribute("tabindex", "0");
      this.handleSelection(e, this.hasAttribute("aria-multiselectable") && this.getAttribute("aria-multiselectable") === "true");
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["disabled", "style", MediaStateReceiverAttributes.MEDIA_CONTROLLER];
    }
  }, {
    key: "formatOptionText",
    value: function formatOptionText(text) {
      return text;
    }
  }]);

  return MediaChromeListbox;
}(globalThis.HTMLElement);

_mediaController = new WeakMap();
_keysSoFar = new WeakMap();
_clearKeysTimeout = new WeakMap();
_metaPressed = new WeakMap();
_clickListener = new WeakMap();
_handleKeyListener = new WeakSet();

handleKeyListener_fn = function handleKeyListener_fn(e) {
  var key = e.key;

  if (key === "Enter" || key === " ") {
    this.handleSelection(e, this.hasAttribute("aria-multiselectable") && this.getAttribute("aria-multiselectable") === "true");
  } else {
    this.handleMovement(e);
  }
};

_keyupListener = new WeakMap();
_keydownListener = new WeakMap();
_updateLayoutStyle = new WeakSet();

updateLayoutStyle_fn = function updateLayoutStyle_fn() {
  var _a;

  var layoutRowStyle = this.shadowRoot.querySelector("#layout-row");
  var isLayoutRow = ((_a = getComputedStyle(this).getPropertyValue("--media-listbox-layout")) == null ? void 0 : _a.trim()) === "row";
  layoutRowStyle.setAttribute("media", isLayoutRow ? "" : "width:0");
};

_getOption = new WeakSet();

getOption_fn = function getOption_fn(e) {
  var composedPath = e.composedPath();
  var index = composedPath.findIndex(function (el) {
    return el.nodeName === "MEDIA-CHROME-OPTION";
  });
  return composedPath[index];
};

_selectOption = new WeakSet();

selectOption_fn = function selectOption_fn(option, toggle) {
  var oldSelectedOptions = _toConsumableArray(this.selectedOptions);

  if (!this.hasAttribute("aria-multiselectable") || this.getAttribute("aria-multiselectable") !== "true") {
    this.options.forEach(function (el) {
      return el.selected = false;
    });
  }

  if (toggle) {
    option.selected = !option.selected;
  } else {
    option.selected = true;
  }

  if (this.selectedOptions.some(function (opt, i) {
    return opt != oldSelectedOptions[i];
  })) {
    this.dispatchEvent(new Event("change", {
      bubbles: true,
      composed: true
    }));
  }
};

_searchOption = new WeakSet();

searchOption_fn = function searchOption_fn(key) {
  var _this2 = this;

  __privateMethod(this, _clearKeysOnDelay, clearKeysOnDelay_fn).call(this);

  var els = this.options;
  var activeIndex = els.findIndex(function (el) {
    return el.getAttribute("tabindex") === "0";
  });

  __privateSet(this, _keysSoFar, __privateGet(this, _keysSoFar) + key);

  var repeatedKey = __privateGet(this, _keysSoFar).split("").every(function (k) {
    return k === key;
  });

  var after = els.slice(activeIndex + (repeatedKey ? 1 : 0)).filter(function (el) {
    return el.textContent.toLowerCase().startsWith(__privateGet(_this2, _keysSoFar));
  });
  var before = els.slice(0, activeIndex - (repeatedKey ? 1 : 0)).filter(function (el) {
    return el.textContent.toLowerCase().startsWith(__privateGet(_this2, _keysSoFar));
  });
  var afterRepeated = [];
  var beforeRepeated = [];

  if (repeatedKey) {
    afterRepeated = els.slice(activeIndex + (repeatedKey ? 1 : 0)).filter(function (el) {
      return el.textContent.startsWith(key);
    });
    beforeRepeated = els.slice(0, activeIndex - (repeatedKey ? 1 : 0)).filter(function (el) {
      return el.textContent.startsWith(key);
    });
  }

  var returns = [].concat(_toConsumableArray(after), _toConsumableArray(before), _toConsumableArray(afterRepeated), _toConsumableArray(beforeRepeated));
  return returns[0];
};

_clearKeysOnDelay = new WeakSet();

clearKeysOnDelay_fn = function clearKeysOnDelay_fn() {
  var _this3 = this;

  clearTimeout(__privateGet(this, _clearKeysTimeout));

  __privateSet(this, _clearKeysTimeout, null);

  __privateSet(this, _clearKeysTimeout, setTimeout(function () {
    __privateSet(_this3, _keysSoFar, "");

    __privateSet(_this3, _clearKeysTimeout, null);
  }, 500));
};

if (!globalThis.customElements.get("media-chrome-listbox")) {
  globalThis.customElements.define("media-chrome-listbox", MediaChromeListbox);
}

var media_chrome_listbox_default = MediaChromeListbox;
export { MediaChromeListbox, createIndicator, createOption, media_chrome_listbox_default as default };